/**
 * ScrollIntoView Stimulus Controller
 *
 * Scrolls the element into view when connected to the DOM.
 * Used to auto-scroll to the active item in the sidebar.
 */

import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

export default class ScrollIntoView extends Controller {
  /**
   * Called when the controller is connected to the DOM.
   * Scrolls the element into view.
   */
  connect() {
    this.element.scrollIntoView({ block: 'center' });
  }
}

application.register('ui--scroll-into-view', ScrollIntoView);
